import { Table, Row, Col, Form } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../../../data/applicationSlice"
import { questionnaire } from "../../../constant/utils"
import React, { useEffect, useState } from "react"

const { updateApplicationData } = actions

const AdditionalQuestions = ({ validationError, setValidationErrors }) => {
    const dispatch = useDispatch()
    const [questions, setQuestions] = useState([...questionnaire])
    const { application } = useSelector((state) => state.application)

    useEffect(() => {
        let startNumber = application.contractorPollutionLiabilityCoverageOnly ? 7 : 8
        let updatedQuestions = questionnaire.map((question, index) => ({
            ...question,
            number: startNumber + index
        }))

        if (!application.contractorPollutionLiabilityCoverageOnly) {
            updatedQuestions[updatedQuestions.length - 1].number = 13
        }

        setQuestions(updatedQuestions)
    }, [application?.contractorPollutionLiabilityCoverageOnly])

    const handleCheckboxChange = (name, option) => {
        dispatch(
            updateApplicationData({
                field: name,
                value: option
            })
        )
        setValidationErrors((prevErrors) => {
            let prev = { ...prevErrors }
            delete prev[name]
            return prev
        })
    }

    const handleTextareaChange = (name, value) => {
        dispatch(
            updateApplicationData({
                field: name,
                value: value
            })
        )
        setValidationErrors((prevErrors) => {
            let prev = { ...prevErrors }
            delete prev[name]
            return prev
        })
    }

    return (
        <div
            id="additional-questions"
            className="additional-questions">
            <Row>
                <Col id="">
                    <Table striped>
                        <thead>
                            <tr key={"thead"}>
                                <th></th>
                                <th></th>
                                <th>Yes</th>
                                <th>No</th>
                            </tr>
                        </thead>
                        <tbody key="table-body">
                            {questions.map((question, index) => (
                                <React.Fragment key={index}>
                                    <tr key={index}>
                                        <td>
                                            <h6>{question.number}.</h6>
                                        </td>
                                        <td>
                                            <h6>{question.question}</h6>
                                            {validationError?.[question.name] && (
                                                <span className="text-error">Please select one of the options</span>
                                            )}
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={application?.[question.name] === true || ""}
                                                onChange={() => handleCheckboxChange(question.name, true)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={application?.[question.name] === false || ""}
                                                onChange={() => handleCheckboxChange(question.name, false)}
                                            />
                                        </td>
                                    </tr>
                                    {question.explanationRequired && application?.[question.name] === true ? (
                                        <tr key={question.name}>
                                            <td colSpan={4}>
                                                <Table bordered>
                                                    <thead>
                                                        <tr key={Math.random() * 10}>
                                                            <th colSpan={4}>
                                                                <strong>Please Explain</strong>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="4">
                                                                <Form.Control
                                                                    as="textarea"
                                                                    className={`form-control ${
                                                                        validationError?.[question.name + "Explanation"]
                                                                            ? "error"
                                                                            : ""
                                                                    }`}
                                                                    value={
                                                                        application?.[question.name + "Explanation"] ||
                                                                        ""
                                                                    }
                                                                    onChange={(e) =>
                                                                        handleTextareaChange(
                                                                            question.name + "Explanation",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>
                                    ) : null}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    )
}

export default AdditionalQuestions
